// export const API_BASE_URL = 'http://localhost:3070/api'; 
// export const SOCKET_API_BASE_URL = 'http://localhost:3070'; 
// export const API_BASE_URL = 'http://192.168.50.184:3070/api'; 
// export const SOCKET_API_BASE_URL = 'http://192.168.50.184:3070'; 
export const GOOGLE_MAPS_API_KEY = 'AIzaSyBAnTD7JWL2wTaA9KSQGlv0Kt5nrDA6b5E';
// export const API_BASE_URL = 'https://sigmaapi.sappsapp.com/api'; 
// export const SOCKET_API_BASE_URL = 'https://sigmaapi.sappsapp.com'; 
export const API_BASE_URL = 'https://api.sappsapp.com/api'; 
export const SOCKET_API_BASE_URL = 'https://api.sappsapp.com'; 

